module.exports = __webpack_public_path__ + "static/media/printableAmar.6bf44e66.png";